import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

const FormReviewHeader = ({ results, selectedResultId, customerDbId, customerId, customerName, onResultSelect }) => {
  const customerPopulated = () => customerDbId && (customerId || customerName);
  const resultsPopulated = () => results && results.length > 0;
  const [isCopiedMessageVisible, setIsCopiedMessageVisible] = useState(false);

  const onSelect = (id) => {
    if (onResultSelect && id) {
      onResultSelect(parseInt(id, 10));
    } else if (!id) {
      onResultSelect(null);
    }
  };

  const getCustomerDescription = () => {
    let description = customerId;

    if (!description && customerName) {
      description = customerName;
    } else if (customerName) {
      description = `${ description } - ${ customerName }`;
    }

    return description;
  };

  const getAccountDescription = (item) => {
    if (!item) {
      return 'NA';
    }

    let description = item.accountNumber;

    if (!description && item.accountName) {
      description = item.accountName;
    } else if (item.accountName) {
      description = `${ description } - ${ item.accountName }`;
    }

    return description;
  };

  const copyAccountNumber = () => {
    if (!selectedResultId) {
      return;
    }

    const matched = results.filter(o => o.id === selectedResultId);
    if (matched && matched.length > 0) {
      const textField = document.createElement('textarea');
      textField.innerText = `${ matched[0].accountNumber } - ${ matched[0].accountName }`;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();

      setIsCopiedMessageVisible(true);

      setTimeout(() => {
        setIsCopiedMessageVisible(false);
      }, 2000);
    }
  };

  return (<div className="form-review-header">
    { customerPopulated() && <div className="form-review-customer">
      <Link to={ `/customer/${ customerDbId }` }>
        <i className="icon icon-people" />
        <span>{ getCustomerDescription() }</span>
      </Link>
    </div> }
    { resultsPopulated() && <div className="form-review-accounts">
      <select
        onChange={ e => onSelect(e.target.value) }
        value={ selectedResultId ? selectedResultId.toString() : '' }
      >
        <option value="">Validation Summary</option>
        {results && results.filter(o => o != null).map((option, i) => (
          <option key={ option.id !== 0 ? option.id : option.accountId } value={ option.id !== 0 ? option.id : option.accountId }>
            { getAccountDescription(option) }
          </option>
        )) }
      </select>
      { selectedResultId != null && <button
        id="btn-copy-account"
        type="button"
        className="icon icon-copy"
        title="Copy Account Number"
        onClick={ () => { copyAccountNumber(); } }
      /> }
      { isCopiedMessageVisible && <div className="form-review-copied-info">
        <span>Copied!</span>
      </div> }
    </div> }
  </div>
  );
};

FormReviewHeader.propTypes = {
  results: PropTypes.arrayOf(PropTypes.shape),
  selectedResultId: PropTypes.number,
  onResultSelect: PropTypes.func,
  customerDbId: PropTypes.number,
  customerId: PropTypes.string,
  customerName: PropTypes.string
};

FormReviewHeader.defaultProps = {
  results: null,
  selectedResultId: null,
  onResultSelect: null,
  customerDbId: null,
  customerId: null,
  customerName: null,
};

export default FormReviewHeader;
